import { Form, Formik } from 'formik';
import { Button, Grid } from '@mui/material';
import styled from 'styled-components';
import PersonIcon from '@mui/icons-material/Person';

import { Loading, FormikContext } from '.';
import { TimerComponent } from 'modules/user/components/profile/timer';
import CustomTextField from 'modules/components/common/form/fields/text-field';
import { VerificationCodeInput } from 'modules/user/components/profile/verification-code';
import { registerSteps } from 'modules/user/constants/register';
import { validationSchema } from 'modules/user/utils/register-utils';

export const LoginForm = ({
  steps,
  actionHandler,
  isLoading,
  timerProps,
  initialValues,
  setInitialValues
}) => {
  const handleSubmit = (values) => {
    actionHandler(values);

    if (steps === registerSteps.sendloginCode) {
      setInitialValues((prev) => ({ ...prev, phone: values.phone }));
    } else if (steps === registerSteps.login) {
      setInitialValues((prev) => ({ ...prev, code: values.code }));
    } else if (steps === registerSteps.signup) {
      setInitialValues((prev) => ({
        ...prev,
        medicalNumber: values.medicalNumber,
        nationalCode: values.nationalCode
      }));
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema(steps)}
      onSubmit={handleSubmit}
    >
      {(props) => {
        let isFormValid;
        if (steps === registerSteps.login) {
          isFormValid = props.values['code']?.length === 4;
        } else if (steps === registerSteps.signup) {
          isFormValid =
            props.values['nationalCode']?.length === 10 &&
            props.values['medicalNumber']?.length > 3;
        } else if (steps === registerSteps.sendloginCode) {
          isFormValid = props.values['phone']?.length === 11;
        }

        return (
          <Form>
            <FormikContext handleSubmit={handleSubmit} steps={steps} />
            <Grid container spacing={'14px'}>
              {registerSteps.sendloginCode === steps && (
                <Grid item xs={12}>
                  <CustomTextField
                    icon={<PersonIcon sx={{ mt: '5px' }} />}
                    name="phone"
                    type="number"
                    placeholder="شماره موبایل"
                    showValueCenter
                    {...props}
                  />
                </Grid>
              )}
              {registerSteps.login === steps && (
                <Grid item xs={12}>
                  <VerificationCodeInput length={4} name="code" {...props} />
                  <TimerComponent {...timerProps} />
                </Grid>
              )}
              {registerSteps.signup === steps && (
                <Grid item xs={12}>
                  <div style={{ marginBottom: '24px' }}>
                    <CustomTextField
                      name="nationalCode"
                      type="number"
                      placeholder="کد ملی"
                      maxLength={10}
                      showValueCenter
                      {...props}
                    />
                  </div>
                  <CustomTextField
                    name="medicalNumber"
                    type="number"
                    placeholder="شماره نظام پزشکی"
                    maxLength={10}
                    showValueCenter
                    {...props}
                  />
                </Grid>
              )}
            </Grid>
            <StyledButton type="submit" steps={steps} disabled={!isFormValid}>
              {isLoading ? (
                <Loading />
              ) : (
                <span>
                  {steps === registerSteps.sendloginCode ? 'ورود' : 'ثبت'}
                </span>
              )}
            </StyledButton>
          </Form>
        );
      }}
    </Formik>
  );
};

const StyledButton = styled(Button)`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  font-family: 'dana-bold';
  margin: ${({ steps }) =>
    steps === registerSteps.signup
      ? '25px auto 0 !important'
      : '98px auto 0 !important'};
  padding: 0;
  border-radius: 50% !important;
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border: 1px solid #ffffff;
  box-shadow: 15px 15px 25px rgba(172, 172, 172, 0.5), -15px -15px 25px #fff;
`;
